import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnowman = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5303 21.4648L31 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4695 21.4741L9 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6471 13.0011C23.4768 13.734 24 14.8059 24 16C24 18.2092 22.2091 20 20 20C17.7909 20 16 18.2092 16 16C16 14.8054 16.5237 13.7331 17.3541 13.0001",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 13H26",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 13V9H23V13",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5006 17.9368C25.6016 19.1449 27 21.4025 27 23.9999C27 27.8659 23.866 30.9999 20 30.9999C16.134 30.9999 13 27.8659 13 23.9999C13 21.4091 14.4071 19.1469 16.4992 17.9365",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgSnowman);
export default ForwardRef;
